import { createMyRolesTable } from '../../../../components/AdminUsersPage/MyRolesTab/createMyRolesTable.ts';
import { $$roles } from '../../../../services/RolesService/model.ts';

export const $$ghsAdminMyRolesTable = createMyRolesTable({
  getManageableRolesFx: $$roles.adminGetManageableRolesFx
});